module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Brais-Blazono-646ea1298071d662809dc953624cc286.png";